<router-outlet></router-outlet>

<app-modal></app-modal>

<ngx-spinner bdColor="rgba(17, 21, 30, 0.6)" size="medium" color="#041e42" type="ball-circus" [fullScreen]="true"
  ><p style="color: white">Loading...</p></ngx-spinner
>

<app-tooltip-container></app-tooltip-container>
